module.exports = __webpack_public_path__ + "static/img/13.65e8e1fd.png";